import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.SETTINGS,
    loadComponent: () =>
      import('./settings.component').then((m) => m.SettingsComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.SETTINGS + '/:section',
    loadComponent: () =>
      import('./settings.component').then((m) => m.SettingsComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.SETTINGS,
    loadComponent: () =>
      import('./settings.component').then((m) => m.SettingsComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.SETTINGS + '/:section',
    loadComponent: () =>
      import('./settings.component').then((m) => m.SettingsComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsModule {}
